import SmallDelete from '@/components/atom/icon/SmallDelete';
import theme from '@/styles/theme';
import Airbridge from '@/utils/airbridge';
import React from 'react';

export type TrackingInfo = {
  campaign?: string;
  contentId?: string;
  contentTitle?: string;
  contentCategory?: string;
  contentSubCategory?: string;
};

type AppInstallTopBannerProps = {
  content: string;
  onClickClose: () => void;
  trackingInfo?: TrackingInfo;
};

const AppInstallTopBanner = ({ onClickClose, content, trackingInfo }: AppInstallTopBannerProps) => {
  const { contentCategory, contentId, contentTitle, campaign, contentSubCategory } = trackingInfo ?? {};

  const onClickInstallApp = () => {
    Airbridge.setDynamicLink({
      campaign: campaign,
      content: content,
      term: '앱 열기',
      sub_id: contentId,
      sub_id_1: contentTitle,
      sub_id_2: contentCategory,
      ...(contentSubCategory && { sub_id_3: contentSubCategory }),
    });
  };

  return (
    <div className='sticky top-[60px] z-[300] flex h-[56px] w-full items-center justify-between bg-gray-700 pr-[20px] pl-[12px]'>
      <div className='flex gap-[12px]'>
        <button onClick={onClickClose}>
          <SmallDelete color={theme.color.gray300} size={24} />
        </button>
        <span className={'typography-ui-15sb text-white'}>비대면 진료 후, 네이버페이 혜택 받기</span>
      </div>
      <div>
        <button
          className='typography-ui-13m h-[32px] rounded-lg border bg-primary-700 px-[8px] text-white'
          onClick={onClickInstallApp}
        >
          앱 열기
        </button>
      </div>
    </div>
  );
};

export default AppInstallTopBanner;
